import i18n from 'i18next';

import {config} from 'config/env';
import {isBasketDiversifyFlagEnabled} from 'constants/recommendation';

export declare type ProductAvailabilityType = (typeof ProductAvailability)[keyof typeof ProductAvailability];

export declare const ProductAvailability: {
  readonly available: 'available';
  readonly outOfStock: 'outOfStock';
  readonly notDeliverable: 'notDeliverable';
  readonly unavailable: 'unavailable';
  readonly notEligible: 'notEligible';
};

export function getIdFromGraphId(graphId: unknown): string | null {
  if (typeof graphId === 'string') {
    const regexToGetId = new RegExp(/([0-9]+)/, 'g');
    const regexToGetIdEx = regexToGetId.exec(graphId);
    const id = regexToGetIdEx?.length ? regexToGetIdEx[0] : null;
    return id;
  } else {
    return null;
  }
}

export enum RecommendationType {
  PERSONALIZED = 'PERSONALIZED',
  CUSTOM = 'CUSTOM'
}

export const getBasketRecommendationTitle = (typeOfRecommendation: string) => {
  switch (typeOfRecommendation) {
    case RecommendationType.CUSTOM:
      return 'recommendations.customListTitle';
    case RecommendationType.PERSONALIZED:
      return 'recommendations.personalizedListTitle';
    default:
      return 'recommendations.customListFor3PTitle';
  }
};

export type SearchCarouselURLParams = {
  userId?: string;
  productVariant?: string;
  isExpressMode?: boolean;
  sameDay?: boolean;
  title?: string;
  accessToken?: string;
  recommendationVariant?: string;
  stores: string[];
  platform?: string;
};

export const geSearchCarouselUrl = (params: SearchCarouselURLParams) => {
  const queryParams = [
    `type=basketRecommendation`,
    params.stores?.length > 0 && `storeCodes=${params.stores.map((s) => s).join(',')}`,
    params?.userId && `userId=${params.userId}`,
    params?.accessToken && `accessToken=${params.accessToken}`,
    params?.productVariant && `productVariant=${params.productVariant}`,
    params?.sameDay && `sameDay=${params.sameDay}`,
    params?.title && `title=${params.title}`,
    params?.recommendationVariant && `recommendationVariant=${params.recommendationVariant}`,
    params?.platform && `platform=${params.platform}`,
    `isDiversify=${isBasketDiversifyFlagEnabled}`,
    `isExpressMode=${params.isExpressMode}`
  ]
    .filter(Boolean)
    .join('&');

  const baseUrl = config.CAROUSEL_MFE_URL;

  return `${baseUrl}/${i18n?.language}?${queryParams}`;
};
